import PropTypes from 'prop-types';
import React from 'react';
import Avatar from 'components/Avatar';
import Icon from 'components/Icon';
import {connect} from 'react-redux';
import {getUserById} from 'state/user/userSelectors';
import {load} from 'state/user/userActions';
import './PersonPill.css';

class PersonPill extends React.Component {
  UNSAFE_componentWillMount() {
    this.props.load(this.props.userId);
  }

  render() {
    const {user, userId, onCloseClick} = this.props;
    if (!user) return null;

    return (
      <div className="PersonPill">
        <div className="PersonPill__Contents">
          <Avatar userId={userId} size={Avatar.sizes.MICRO} />
          <div className="PersonPill__Name">{user.displayName}</div>
          <Icon
            onClick={onCloseClick}
            className="PersonPill__Remove"
            icon={Icon.OPTIONS.X}
            size={Icon.SIZES.NANO}
          />
        </div>
      </div>
    );
  }
}

PersonPill.propTypes = {
  userId: PropTypes.node.isRequired,
  onCloseClick: PropTypes.func.isRequired,
};

export default connect(
  (state, {userId}) => ({
    user: getUserById(state, userId),
  }),
  {
    load,
  }
)(PersonPill);
